export const thePixelArtist = {
  name: "The Pixel Artist",
  excerpt: "Pixel Art Mobile App",
  image: "simpleLeadTracker.webp",
  localUrl: "the-pixel-artist",
  url: "#",
  description: "The Pixel Artist is a tool for creating pixel art on your phone. It lets artists create simple pixel art, and the export them as images to share.",
  challenge: "Building art tools is never easy, and The Pixel Artist is no exception. There was some technical challenges getting the drawing to work properly, as well as some discovery work to tap into native phone controls to save images to the user's device.",
  solution: "The Pixel Artist ended up being a hybrid add that's built with Javascript but taps into some Cordova plugins to give some native functionality. This allowed us to let users save their art to their device, which was critical to make this appeal to anyone..",
  tech: ["Javascript", "HTML5", "Cordova"],
  images: ["simpleLeadTracker.webp", "simpleLeadTracker.webp", "simpleLeadTracker.webp"]
}
